import ButtonIcon from "@wg/wows-react-uikit/ButtonIcon";
import classNames from "classnames";
import * as React from "react";
import styles from "./ButtonAction.scss";

export type IProps = {
  tooltipContent?: any;
  action: "ok" | "cancel";
  isDisabled: boolean;
  onClick: (event: React.MouseEvent<EventTarget>) => void;
};

class ButtonAction extends React.PureComponent<IProps, any> {

  render() {

    const classNameContainer = classNames(styles.container, {
      [styles.isDisabled]: this.props.isDisabled
    });

    return (
      <div className={classNameContainer}>
        <ButtonIcon type={this.props.action=="ok" ? "check" : "cross"} isDisabled={this.props.isDisabled} onClick={this.props.onClick} tooltipContent={this.props.tooltipContent}/>
      </div>
    )
  }
}

export default ButtonAction;